import React from "react";
import MegaMenu from "@insightfulscience/atomic-react/MegaMenu";
import MegaMenuTitle from "@insightfulscience/atomic-react/MegaMenu/Title";
import MegaMenuItem from "@insightfulscience/atomic-react/MegaMenu/Item";
import { MegaMenuCol } from "@insightfulscience/atomic-react/MegaMenu/Grid";
import { useLocale } from "@insightfulscience/i18";
import routes from "@src/routes";

const ProductDropdown = () => {
	const [t] = useLocale("common");

	return (
		<MegaMenu>
			<MegaMenuCol lg={3} md={12} spacing={{ lg: { ml: 54 } }}>
				<MegaMenuTitle uppercase>{t("MENU.PRODUCT")}</MegaMenuTitle>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.overview.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.OVERVIEW")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.classicAnalysis.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.CLASSICAL_ANALYSIS")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.highDimensionalAnalysis.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.DIMENSIONAL_ANALYSIS")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.cloudPlatform.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.CLOUD_PLATFORM")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.dataManagement.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.DATA_MANAGEMENT")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.updates.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.UPDATES")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
			</MegaMenuCol>
			<MegaMenuCol lg={3} md={12} spacing={{ lg: { ml: 16 } }}>
				<MegaMenuTitle uppercase>{t("MENU.INTEGRATIONS")}</MegaMenuTitle>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.prismIntegration.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.GRAPHPAD_PRISM")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.product.subRoutes.easyPanelIntegration.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.product.EASY_PANEL")}
					</MegaMenuItem.Link>
				</MegaMenuItem>
			</MegaMenuCol>
		</MegaMenu>
	);
};

export default ProductDropdown;
